import { MouseEvent, useState } from 'react'

import { List, ListItemText } from '@mui/material'

import { StyledListItemButton } from './invoice-list.styles'

import {
  InvoiceResponse,
  TransformInvoiceResponse,
} from 'store/invoices/invoices.types'
import { useDispatch } from 'react-redux'
import {
  clearSelectedCustomerId,
  setSelectedCustomerId,
} from 'store/invoices/invoices.slice'

interface InvoiceListProps {
  invoices: TransformInvoiceResponse[]
}

interface ListItemProps {
  listText: string
  selected: boolean
  handleListItemClick: (
    event: any,
    index: number,
    invoice?: InvoiceResponse
  ) => void
}

const ListItem = ({
  listText,
  selected,
  handleListItemClick,
}: ListItemProps) => (
  <StyledListItemButton
    selected={selected}
    onClick={(event) => handleListItemClick(event, 0)}
  >
    <ListItemText>{listText}</ListItemText>
  </StyledListItemButton>
)

const InvoiceList = ({ invoices }: InvoiceListProps) => {
  const dispatch = useDispatch()

  const [selectedIndex, setSelectedIndex] = useState(0)

  const handleListItemClick = (
    _event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setSelectedIndex(index)
  }

  return (
    <List>
      <ListItem
        listText="All"
        selected={selectedIndex === 0}
        handleListItemClick={(event) => {
          handleListItemClick(event, 0)
          dispatch(clearSelectedCustomerId())
        }}
      />
      {invoices.map((invoice, index) => (
        <ListItem
          key={invoice?.customerName}
          listText={invoice?.customerName}
          selected={selectedIndex === index + 1}
          handleListItemClick={(event) => {
            handleListItemClick(event, index + 1)
            dispatch(setSelectedCustomerId(invoice?.invoiceData[0]?.customerId))
          }}
        />
      ))}
    </List>
  )
}

export default InvoiceList
